import React from 'react'
import { Button, Dialog, DialogContent, Slide } from '@mui/material'
import Lottie from 'lottie-react'
import successAnimation from "../../animations/success_animation.json"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

function SuccessAlertModal({
    open,
    buttonTitle,
    onClick
}) {

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            aria-describedby="data-feed-form-dialog"
            fullWidth={true}
            maxWidth={"sm"}
        >
            <DialogContent>
                <Lottie
                    animationData={successAnimation}
                    loop={true}
                />
                <Button
                    variant='contained'
                    sx={{
                        mt: 4
                    }}
                    fullWidth
                    onClick={onClick}
                >
                    {buttonTitle}
                </Button>
            </DialogContent>
        </Dialog>
    )
}

export default SuccessAlertModal